exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".individual-notification-group{margin-bottom:24px;border-radius:4px;overflow:hidden}.individual-notification-group .group-header{padding:12px 16px;background-color:#f5f5f5;border-radius:4px 4px 0 0;margin-bottom:0;display:flex;align-items:center;gap:8px}.individual-notification-group .notification-list{display:flex;flex-direction:column;border:1px solid #e0e0e0;border-top:none;border-radius:0 0 4px 4px;background-color:#fff}", ""]);

// exports
